/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import EmailTemplatesidEmailTemplate from './EmailTemplatesidEmailTemplate';

/**
 * The EmailTemplatesIdBody model module.
 * @module model/EmailTemplatesIdBody
 * @version v0.3
 */
export default class EmailTemplatesIdBody {
  /**
   * Constructs a new <code>EmailTemplatesIdBody</code>.
   * @alias module:model/EmailTemplatesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailTemplatesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailTemplatesIdBody} obj Optional instance to populate.
   * @return {module:model/EmailTemplatesIdBody} The populated <code>EmailTemplatesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailTemplatesIdBody();
      if (data.hasOwnProperty('email_template'))
        obj.emailTemplate = EmailTemplatesidEmailTemplate.constructFromObject(data['email_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EmailTemplatesidEmailTemplate} emailTemplate
 */
EmailTemplatesIdBody.prototype.emailTemplate = undefined;
